import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

// ===================== FIREBASE
// const FIREBASE_DEV_CONFIG = {
//   apiKey: 'AIzaSyDbrLv_zmap7IERtUbBSzEbFoKMoaVb7Rs',
//   authDomain: 'eventregistrationsoftware.firebaseapp.com',
//   projectId: 'eventregistrationsoftware',
//   storageBucket: 'eventregistrationsoftware.appspot.com',
//   messagingSenderId: '691082884366',
//   appId: '1:691082884366:web:cd8ad74f2d2dba9b46535f',
//   measurementId: 'G-M0CNV0HW48',
// }

const FIREBASE_DEV_CONFIG = {
  apiKey: 'AIzaSyB1dZBMjlcLPrx5G7gwN3DbRU--SfvvQ3A',
  authDomain: 'staging-signup-software.firebaseapp.com',
  projectId: 'staging-signup-software',
  storageBucket: 'staging-signup-software.appspot.com',
  messagingSenderId: '1029926384970',
  appId: '1:1029926384970:web:6cb87e2a0fa9f3bb71fdb3',
  measurementId: 'G-MPCGS5KNXK',
}

// const FIREBASE_PROD_CONFIG = {
//   apiKey: 'AIzaSyBPUAoSuOdLRfg7LR1Oey-MQFFHj6ExGgU',
//   authDomain: 'stl-swing-dance.firebaseapp.com',
//   projectId: 'stl-swing-dance',
//   storageBucket: 'stl-swing-dance.appspot.com',
//   messagingSenderId: '683859120154',
//   appId: '1:683859120154:web:354883694379ca7b5801a3',
//   measurementId: 'G-MC5XJDYGJ5',
// }
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const FIREBASE_PROD_CONFIG = {
  apiKey: 'AIzaSyBouKR_bz-1wqc2mPCjYOA-4czK-Gaxt98',
  authDomain: 'signup-software.firebaseapp.com',
  projectId: 'signup-software',
  storageBucket: 'signup-software.appspot.com',
  messagingSenderId: '913776272706',
  appId: '1:913776272706:web:7fd584125502bc8dc914db',
  measurementId: 'G-G6KXCL2WKW',
}

// Keyed on MODE (not PROD): only a real production build uses live Firebase.
// `vite build --mode staging` and the dev server both use the staging project
// (FIREBASE_DEV_CONFIG = staging-signup-software). Without this, a --mode staging
// build resolves import.meta.env.PROD === true → live Firebase, breaking admin
// logins against the staging uids.
const FIREBASE_CONFIG =
  import.meta.env.MODE === 'production'
    ? FIREBASE_PROD_CONFIG
    : FIREBASE_DEV_CONFIG

export const firebaseApp = initializeApp(FIREBASE_CONFIG)
export const auth = getAuth(firebaseApp)

// export const analytics = getAnalytics(firebaseApp)
